export default "__VITE_ASSET__DJZgl$em__"